import React from 'react';
import { Loader as RsLoader } from 'rsuite';

interface LoaderProps {
  size?: 'sm' | 'md' | 'lg';
  fullPage?: boolean;
}

export const Loader: React.FC<LoaderProps> = ({ size = 'md', fullPage = false }) => {
  if (fullPage) {
    return <RsLoader backdrop center size="lg" />;
  }

  return <RsLoader size={size} />;
};

export default Loader;
